module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.showAdjustmentModal) ? _c('interest-adjustment', {
    attrs: {
      "noteId": _vm.note.noteId,
      "isSubmitDisabled": _vm.isSubmitDisabled,
      "submitAction": _vm.submitAdjustment,
      "cancelAction": _vm.cleanAdjustmentInformation
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]), _c('small', [_vm._v(" Required fields")])]), _vm._v(" "), _c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Add new INT-ADJ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Adjustment amount"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    class: {
      'form-control-error': _vm.errors.has('interest-amount')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixedAdjustmentAmount),
      expression: "fixedAdjustmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "currency",
    attrs: {
      "name": "interest-amount",
      "type": "number",
      "value": "2",
      "placeholder": "0.00",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.fixedAdjustmentAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fixedAdjustmentAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('interest-amount') || _vm.adjustmentAmount == 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("The adjustment amount cannot be zero. Please enter a different amount.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Date"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group date"
  }, [_c('date-picker', {
    attrs: {
      "disabled": "",
      "value": _vm.adjustmentDate,
      "config": _vm.dateConfig
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Comment"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    class: {
      'form-control-error': _vm.errors.has('interest-comment')
    },
    attrs: {
      "rows": "4",
      "id": "comment",
      "name": "interest-comment",
      "placeholder": "Enter your comments here"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('interest-comment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("The comment field cannot be empty. Please enter a comment.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Resulting current INT-PAID")])]), _vm._v(" "), _c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Interest paid amount")]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    attrs: {
      "disabled": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPaid),
      expression: "interestPaid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        min_value: 0
      }),
      expression: "{min_value: 0}"
    }],
    staticClass: "currency",
    attrs: {
      "name": "interest-paid",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.interestPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestPaid = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.interestPaid < 0.005) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("This interest payment would be zero or negative once rounded to two decimal places. Please change the adjustment so that the interest payment will be at least $0.01 once rounded to two decimal places.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Resulting current interest accrued")])]), _vm._v(" "), _c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Interest accrued amount")]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    attrs: {
      "disabled": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestAccrued),
      expression: "interestAccrued"
    }],
    staticClass: "currency",
    attrs: {
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.interestAccrued)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestAccrued = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), (_vm.isVisibleEditCommentModal) ? _c('edit-transaction-comment', {
    attrs: {
      "closeAction": _vm.closeEditCommentModal,
      "transaction": _vm.transaction,
      "loadNoteDetail": _vm.loadNoteDetail
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n          Note details\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.note.noteId))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.note.currentBalance)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatTerm(_vm.note.interestTerm)))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.note.openedOn)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatRate(_vm.note.interestRate)))])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.note.maturityDate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.note.originalBalance)))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [(_vm.note.status == 'closed') ? _c('p', {
    staticClass: "label label-danger"
  }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'cancelled') ? _c('p', {
    staticClass: "label label-danger"
  }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'pending') ? _c('p', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'open') ? _c('p', {
    staticClass: "label label-success"
  }, [_vm._v("Open")]) : _vm._e()])])]), _vm._v(" "), (_vm.note.cusip) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.note.cusip))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-10 top-margin bottom-margin"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "type": "submit",
      "disabled": _vm.isRedeemDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToRedeem()
      }
    }
  }, [_vm._v("Redeem")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "disabled": _vm.isTransferDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToTransfer()
      }
    }
  }, [_vm._v("Transfer")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "disabled": _vm.isAddFundsDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToAddFunds()
      }
    }
  }, [_vm._v("Add funds")])])]), _vm._v(" "), (_vm.adjustmentWasSuccessfull) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.adjustmentWasSuccessfull = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" The interest adjustment was saved successfully.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n            Transaction list\n        ")]), _vm._v(" "), (_vm.note.transactions.length === 0) ? _c('div', [_vm._m(10)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--md cols-7': _vm.note.transactions.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped table-transaction"
  }, [_c('thead', [_c('tr', [_c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "transactionId",
      "label": "Id"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "type",
      "label": "Transaction type"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "amount",
      "label": "Amount"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "createdAt",
      "label": "Date"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "updatedAt",
      "label": "Last updated date"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "status",
      "label": "Status"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedTransactions), function(transaction) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(transaction.type === 'ACCR-INT' && _vm.note.status === 'closed')),
        expression: "!(transaction.type === 'ACCR-INT' && note.status === 'closed')"
      }],
      key: transaction.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.transactionId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(transaction.type, 'admin', transaction.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "aligned-amounts-container"
    }, [_c('span', {
      staticClass: "whole"
    }, [_vm._v(_vm._s(_vm.getWholeAmount(transaction.amount)))]), _vm._v(" "), _c('span', [_vm._v(".")]), _vm._v(" "), _c('span', {
      staticClass: "decimal"
    }, [_vm._v(_vm._s(_vm.getDecimals(transaction.amount)))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.status == 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (transaction.status == 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PRE-PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pre-pending")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (transaction.status == 'BATCHED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Batched")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.comment) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (transaction.comment),
        expression: "transaction.comment",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "transaction-comment"
    }, [_vm._v(_vm._s(transaction.comment))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details edit-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openEditCommentModal(transaction)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.canViewRedeemDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canViewTransferDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewTransferDetail()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canViewAddFundsDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToAddFunds()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canRerunInterestAccrual(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button",
        "disabled": _vm.note.status === 'closed'
      },
      on: {
        "click": function($event) {
          _vm.isRerunInterestAccrualDisabled ? (_vm.handleRerunInterestAccrualDisabledShowModal()) : (_vm.handleRerunInterestAccrual(_vm.note.id))
        }
      }
    }, [_vm._v("Re-run interest accrual")]) : _vm._e(), _vm._v(" "), (_vm.canTransactionBeFailed(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.failTransaction(transaction.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.markAsFailedMessage(transaction)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2 top-margin bottom-margin"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-redeem",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAdjustmentPossible
    },
    on: {
      "click": function($event) {
        _vm.showAdjustmentModal = true
      }
    }
  }, [_vm._v("Interest adjustment")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Id:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Current amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Term:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Open Date:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Rate:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Maturity:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Original amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("CUSIP:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info"
  }), _vm._v(" No transactions found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6e1d476","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteDetail.vue
// module id = 2206
// module chunks = 1